import React from 'react'

import Relazsizes from 'relazsizes'

import IGSvg from 'components/atoms/SVGIcons/InstagramFull'
import MailSvg from 'components/atoms/SVGIcons/Mail'
import FBSvg from 'components/atoms/SVGIcons/FacebookFull'
import PhoneSvg from 'components/atoms/SVGIcons/Phone'
import WebSvg from 'components/atoms/SVGIcons/Web'

import Container from 'components/atoms/Container'
import Typography from 'components/atoms/Typography'
import SectionContainer from 'components/atoms/SectionContainer'
import config from 'config'

const { assets_url: assetsUrl } = config
const pintariaAssetsPath = `${assetsUrl}/assets/img/pintaria`

const PintariaContact = () => {
  const contacts = [
    {
      icon: <WebSvg fill="#0fc3c4"/>,
      link: 'https://pintaria.com/',
      name: 'https://pintaria.com/',
      media: 'Website',
    },
    {
      icon: <MailSvg fill="#0fc3c4"/>,
      link: 'mailto:info@pintaria.com?',
      name: 'info@pintaria.com',
      media: 'Email',
    },
    {
      icon: <PhoneSvg fill="#0fc3c4"/>,
      link: 'tel:+62-81382765493',
      name: '+62 813-8276-5493',
      media: 'Telepon',
    },
    {
      icon: <FBSvg fill="#0fc3c4"/>,
      link: 'https://www.facebook.com/pintariaindonesia',
      name: 'pintariaindonesia',
      media: 'Facebook',
    },
    {
      icon: <IGSvg fill="#0fc3c4"/>,
      link: 'https://www.instagram.com/pintaria_id',
      name: '@pintaria_id',
      media: 'Instagram',
    },
  ]
  return (
    <div className="pintaria-contact">
      <SectionContainer
        paddingTop={80}
        paddingBottom={120}
        backgroundColor="transparent"
      >
        <Container>
          <Relazsizes src={`${pintariaAssetsPath}/description/pintaria-logo.png`} className="pintaria-contact__logo" />
          <div className="pintaria-contact__box">
            {
              contacts.map((item, idx) => (
                <div className="pintaria-contact__col" key={`social-media-${idx}`}>
                  <div className="pintaria-contact__icon">
                    {item.icon}
                  </div>
                  <Typography component="p" variant="body" className="pintaria-contact__media">{item.media}</Typography>
                  <a href={item.link} rel="noopener noreferrer" target="_blank" className="pintaria-contact__link">{item.name}</a>
                </div>
              ))
            }
          </div>
        </Container>
      </SectionContainer>
      <style jsx>
        {`
          .pintaria-contact {
            :global(&__logo) {
              height: 80px;
              filter: brightness(10);
              margin-bottom: 32px;
            }
            @media screen and (min-width: 768px) {
              background-image: url(${pintariaAssetsPath}/banner/contact.jpg);
              background-repeat: no-repeat;
              background-position: top;
              background-size: cover;

              &__icon {
                margin-right: 20px;
              }
            }
            @media screen and (max-width: 767px) {
              background-color: #0291ff;
              :global(&__media) {
                display: none;
              }
            }
            &__box {
              max-width: 364px;
              padding: 24px;
              margin-bottom: 20px;

              border-radius: 8px;
              box-shadow: 0 6px 16px 0 rgba(30, 63, 107, 0.45);
              background-color: #ffffff;
              background-color: #fff;
            }
            &__col {
              display: flex;
            }
            &__icon {
              margin-bottom: 10px;
              margin-top: 5px;
            }
            :global(&__media) {
              flex-basis: 5em;
              margin-bottom: 10px;
            }
            &__link{
              margin-bottom: 10px;
              display: inline-block;
              font-size: 16px;
              font-weight: bold;
              line-height: 2;
              color: #1a344f;
              margin-left: 15px;
            }
          }
        `}
      </style>
    </div>
  )
}


export default PintariaContact
